<template>
  <div class="line-item"> 
      <div class="heading" :class="{'visible':config.visible}" style="display:flex;"> 
        <v-icon class="ml-2 mr-2 move-nmea pointer-move" small style="flex-grow:0!important" left>mdi-cursor-move</v-icon>                  
        <v-btn class="nmeabtn mx-0 pr-2" flat @click.prevent="showDetail = !showDetail" :title="$t(showDetail?'Admin.Nmea.HideConfigTooltip':'Admin.Nmea.ShowConfigTooltip')" >{{config.name}} <v-icon :class="{rotate180:showDetail}" style="margin-left:auto">mdi-chevron-down</v-icon></v-btn>                        
      </div>      
      <v-expand-transition>                    
      <div v-if="showDetail" class="panel pa-2" >                   
        <strong>{{$t("Admin.Nmea.AvailableField")}}</strong>
        <div class="panel flex-grow-1">
          <draggable class="list-group" v-model="availableFields" v-bind="dragOptions" style="height:100%">  
            <v-chip small v-for="field in availableFields" :key="field.name">
              <v-icon class="ml-0 mr-2 pointer-move move-field" small style="flex-grow:0!important" left>mdi-cursor-move</v-icon>
              {{field.name}}
            </v-chip>
          </draggable>
        </div>    
        <div>
          <strong>{{$t("Admin.Nmea.DisplayField")}}</strong>
          <div class="d-flex">
            <div class="mr-1 d-flex flex-column">              
              <div class="panel column flex-grow-1">
                <draggable class="list-group" v-model="col1" v-bind="dragOptions" style="height:100%">  
                  <admin-nmea-field v-for="field in col1" :showGraphProps="config.name != 'computed'" :key="`col1_${field.name}`" :field="field" />
                </draggable>
              </div>
            </div>
            <div class="mx-1 d-flex flex-column">              
              <div class="panel column flex-grow-1">
                <draggable class="list-group" v-model="col2" v-bind="dragOptions" style="height:100%">  
                  <admin-nmea-field v-for="field in col2" :showGraphProps="config.name != 'computed'" :key="`col2_${field.name}`" :field="field" />
                </draggable>
              </div>
            </div>
            <div class="d-flex flex-column">              
              <div class="ml-1 panel column flex-grow-1">
                <draggable class="list-group" v-model="col3" v-bind="dragOptions" style="height:100%">  
                  <admin-nmea-field v-for="field in col3" :showGraphProps="config.name != 'computed'" :key="`col3_${field.name}`" :field="field" />
                </draggable>
              </div>
            </div>
          </div>
        </div>    
      </div>
    </v-expand-transition>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import draggable from 'vuedraggable'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { NmeaConfigField } from '@/models/datapool/NmeaConfigField'
import AdminNmeaField from '@/components/admin/nmea/AdminNmeaField.vue'
import { NmeaConfig } from '@/models/datapool/NmeaConfig'

@Component({
  name: 'AdminNmeaFields',
  props:{
    fields:{
      type:Array,
      default:()=>[]
    },
    config:{
      type:Object, 
      default:() => new NmeaConfig()
    }
  },
  components:{draggable,AdminNmeaField}
})
export default class AdminNmeaFields extends Vue {      
   config!:NmeaConfig   
   fields!:Array<string>
   showDetail = false

   get availableFields()  {
     return [...this.config.colHidden.filter(f => this.config.col1.findIndex(i => i.name == f.name) == -1 
                          && this.config.col2.findIndex(i => i.name == f.name) == -1
                          && this.config.col3.findIndex(i => i.name == f.name) == -1
                          && this.fields.findIndex(i => i == f.name) > -1),
             ...this.fields.filter(f => this.config.col1.findIndex(i => i.name == f) == -1 
                          && this.config.col2.findIndex(i => i.name == f) == -1
                          && this.config.col3.findIndex(i => i.name == f) == -1
                          && this.config.colHidden.findIndex(i => i.name == f) == -1)
                .map(f => new NmeaConfigField({name:f}))]             
   }

   set availableFields(newValues){
     this.config.colHidden = newValues
   }   


   get col1()  {
     return this.config.col1.filter(f => this.fields.findIndex(i => i == f.name) > -1)
   }

   set col1(newValues){
     this.config.col1 = newValues
   }

   get col2()  {
     return this.config.col2.filter(f => this.fields.findIndex(i => i == f.name) > -1)
   }

   set col2(newValues){
     this.config.col2 = newValues
   }

   get col3()  {
     return this.config.col3.filter(f => this.fields.findIndex(i => i == f.name) > -1)
   }

   set col3(newValues){
     this.config.col3 = newValues
   }

  mounted(){
     
   }
  

   get dragOptions() {
      return {
        animation: 0,
        group: `nmea_${this.config.name}`,
        disabled:false,
        handle:'.move-field',
        ghostClass: "ghost"
      }
   }

}

</script>

<style scoped>
.heading{
  background-color: #ddd;
}
.loaded .heading{
  background-color: #16BA82;
}
.lazy .heading{
  background-color: #05BDED;
}
.panel{
  border: 1px solid #ddd;
}
.column{
  min-height: 100px;
}
</style>

<style>



.pointer-move{
  cursor: move;
}

.nmeabtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.nmeabtn{
  flex:1 0 auto;
}

.nmeabtn .v-btn__content{
  justify-content: flex-start;
}



</style>